export default __webpack_public_path__ + "static/media/financialPerformancebg.49553de1.svg";